import { applyHightlightForQuickSearches } from '@engine/features/quick_search';
import { exists } from '@engine/lib/utility/exists';
import { jqueryCssInit } from '@engine/features/toggle_booleans';
import refreshComponent from '@engine/features/refresh_component'; // Terminal, MIDs & etc.

function listenForAjaxPaginationClick() {
  if (!exists($('.pagination-wrapper a'))) {
    return false;
  }

  $(document).on('click', '.pagination-wrapper li:not(.disabled) a', function (e) {
    e.preventDefault();
    $.ajax({
      url: $(this).attr('href'),
      beforeSend: function beforeSend() {
        $('.list-container .table-responsive').html('');
        $('.list-container .table-loader').removeClass('hidden');
      },
      success: function success(data) {
        $('.list-container').html($(data).find('.list-container').html());
        $('.list-container .table-loader').addClass('hidden');
        var componentsToRefresh = ['UserEnabled', 'UserLoginEnabled'];
        applyHightlightForQuickSearches();
        jqueryCssInit();
        componentsToRefresh.map(function (component) {
          return refreshComponent(component);
        });
      }
    });
  });
}

export { listenForAjaxPaginationClick };